import React, { useEffect } from "react";
import "./aboutUs.css";
import Meta from "utils/meta";
import FaqBlock from "Component/FaqBlock/faqBlock";

const AboutUs = () => {
  const questions = [
    "Who are the founders of Realtor",
    "What year was Realtor founded?",
    "Where are the headquarters of Realtor located?",
    "Is Realtor a dedicated CRM for the real estate industry?",
    "What awards has Realtor CRM won?",
    "Does Realtor provide services for real estate developers and brokers?",
  ];
  const answers = [
    "Realtor was established by its founders Ketan Sabnis and Vinayak Katkar.",
    "Realtor was founded in the year 2011.",
    "The headquarters of Realtor are situated in Pune, India.",
    "Absolutely, Realtor exclusively serves as a CRM tailored for the real estate industry.",
    "Realtor CRM has won several awards, including the Best Real Estate CRM Software, Among 20 most promising CRM providers by CIO Magazine. Winner of the Proptech CRM solution of the year and #Rank 1 easiest to use real estate CRM Globally by G2, High performer summer 2023.",
    "Yes, Realtor offers its services to both real estate developers and brokers. Its solutions encompass a spectrum of real estate business aspects, including lead management, property tracking, and communication functionalities.",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Meta title="About US | The Realtor Desk" description="" />
      <div className="aboutUs-container">
        <div className="aboutUs-heading">
          <h1>About Us</h1>
        </div>
        <div className="aboutUs-content">
          <h3>Best Prop Tech Team in the Real Estate Industry</h3>
          <p>
            Established in 2011, Realtor has become a one-stop integrated Real
            Estate CRM solution for the real estate industry. Combining
            marketing, sales, and customer service in one comprehensive package
            - we empower real estate businesses with an edge in automating their
            workflows, thereby amplifying efficiency & productivity. The
            solution integrates multiple operations into a single platform,
            making way for the efficient targeting of leads & customers based on
            their data points. This information can be harnessed to personalize
            customer engagements through automated marketing campaigns that
            capture maximum ROI from every lead or prospect!.
          </p>
          <p>
            We traverse the complicated real estate industry with one mission;
            To create an intuitive and streamlined platform that makes managing
            customer relationships simple. Realtor as India’s only integrated,
            complete end-to-end solution has been chosen by 1000+ real estate
            brands and has bagged won six awards and recognitions in just over a
            decade, making it one of the best real estate CRMs in the country.{" "}
          </p>
          <p>
            As a torchbearer of the Indian PropTech landscape, dedicated to
            revolutionising the Real Estate industry, Realtor Prop Tech a
            meticulously crafted business portfolio of 13+ PropTech products &
            solutions with operations in 50+ cities, 600 Real Estate Developer
            relations, 7500+ Channel Partners, 8000+ active home buyers, 4300+
            active RaaS customers and 520+ active SaaS customers. The company
            builds and operates PropTech products, services, and platforms
            catering to the intricacies of the B2B, B2C, B2B2C, and D2C Real
            Estate Value Chains.
          </p>
          <p>
            Realtor Prop Techs’ business portfolio of products and solutions
            encompasses nearly 75% of India’s PropTech market potential and is
            built on cutting edge technologies such as Artificial Intelligence,
            Machine Learning, Blockchain, Augmented Reality, and Virtual
            Reality. At the core of Aurum’s strategy lies a triad: Technology,
            Services, and Capital.
          </p>
        </div>
        <FaqBlock
            questions={questions}
            answers={answers}
        />
      </div>
    </div>
  );
};

export default AboutUs;
